/* Barra de compra flotante.
   Aparece cuando la persona ha bajado lo suficiente y se esconde mientras haya
   otro botón de comprar a la vista, para no repetir la misma llamada dos veces. */
(function () {
  'use strict';

  function iniciar() {
    var barra = document.querySelector('[data-mt-barra]');
    // Si aún no está en la página, se reintenta en el siguiente aviso del
    // navegador; y si ya se preparó una vez, no se vuelve a enganchar.
    if (!barra || barra.getAttribute('data-mt-listo') === '1') return;
    barra.setAttribute('data-mt-listo', '1');

    // Porcentaje de pantalla que hay que bajar antes de que asome.
    var pct = parseInt(barra.getAttribute('data-mt-aparece'), 10);
    if (isNaN(pct)) pct = 80;

    // Otros botones de comprar de la página (los de las secciones normales).
    var otrosBotones = [];
    document.querySelectorAll('.mt-hero__cta a, .mt-cta__fila a, .mt-pdp__cta, [data-mt-add-btn]').forEach(function (el) {
      if (!barra.contains(el)) otrosBotones.push(el);
    });

    // Se mide en el momento en vez de usar un observador: el observador deja de
    // avisar cuando la pestaña está en segundo plano y la barra se quedaba con
    // un dato viejo (creyendo que aún había un botón a la vista).
    function hayBotonALaVista() {
      var alto = window.innerHeight;
      for (var i = 0; i < otrosBotones.length; i++) {
        var r = otrosBotones[i].getBoundingClientRect();
        if (r.height > 0 && r.top < alto * 0.92 && r.bottom > 0) return true;
      }
      return false;
    }

    function pintar() {
      var umbral = window.innerHeight * (pct / 100);
      var haBajado = window.pageYOffset > umbral;
      barra.classList.toggle('is-visible', haBajado && !hayBotonALaVista());
    }

    var esperando = false;
    window.addEventListener('scroll', function () {
      // En una pestaña en segundo plano el navegador congela
      // requestAnimationFrame, así que ahí se recalcula directamente.
      if (document.hidden) { pintar(); return; }
      if (esperando) return;
      esperando = true;
      window.requestAnimationFrame(function () {
        pintar();
        esperando = false;
      });
    }, { passive: true });

    window.addEventListener('resize', pintar, { passive: true });
    // Al volver a la pestaña se repinta por si se movió estando oculta.
    document.addEventListener('visibilitychange', pintar);
    pintar();
  }

  // Se intenta en varios momentos porque, según cómo coloque Shopify el
  // archivo, este puede ejecutarse antes de que la barra exista en la página.
  iniciar();
  document.addEventListener('DOMContentLoaded', iniciar);
  window.addEventListener('load', iniciar);

  // El editor de Shopify recarga secciones sueltas sin refrescar la página.
  document.addEventListener('shopify:section:load', function (e) {
    var barra = document.querySelector('[data-mt-barra]');
    if (barra) barra.removeAttribute('data-mt-listo');
    iniciar();
  });
})();
